import range from 'lodash/range'

const localeIsKR = () => I18n.language === 'lng_ko'

function lettersStragtegy () {
  switch (I18n.language) {
    case 'lng_ko':
      return new KoLettersStratgey()
    case 'lng_xz':
      return new DefaultLettersStrategy()
    default:
      return new DefaultLettersStrategy()
  }
}

function allLetters () {
  return lettersStragtegy().letters()
}

class KoLettersStratgey {
  letters () {
    const krLetters = ['가', '까', '나', '다', '따', '라', '마', '바', '빠', '사', '싸', '아', '자', '짜', '차', '카', '타', '파', '하', '#']
    const enLetters = String.fromCharCode(...range('a'.charCodeAt(0), 'z'.charCodeAt(0) + 1)).split('')
    const allLetters = []
    let hash = {}
    krLetters.forEach((kr, index) => {
      hash = {}
      hash.currentLangLetter = kr
      hash.enLetter = enLetters[index]
      allLetters.push(hash)
    })
    return allLetters
  }
}

class DefaultLettersStrategy {
  letters () {
    const enLetters = String.fromCharCode(...range('a'.charCodeAt(0), 'z'.charCodeAt(0) + 1)).split('')
    const allLetters = []
    let hash = {}
    enLetters.forEach(en => {
      hash = {}
      hash.currentLangLetter = en
      hash.enLetter = en
      allLetters.push(hash)
    })
    return allLetters
  }
}

export {
  localeIsKR,
  allLetters
}
